<template>
  <section id="dashboard">
    <!-- flag demo -->
    <subscription-flag-demo v-if="isDemo"> </subscription-flag-demo>
    <subscription-flag v-if="isPaymentEmpty" :show="isPaymentEmpty"> </subscription-flag>
    <subscription-flag-free v-if="!isPaymentEmpty && isFreemium" :show="showFlagFree" @close="showFlagFree = false"> </subscription-flag-free>
    <flag-marketing-empty v-if="!isPaymentEmpty && emptyMarketing" :show="showFlagMarketing" @close="showFlagMarketing = false"> </flag-marketing-empty>

    <!-- modal onboarding -->
    <modal-onboarding
      v-if="showOnboarding"
      :show="true"
      menuName="Menu"
    ></modal-onboarding>

    <!-- modals versio -->
    <modal-new-version
      :show="showModalNewVersion"
      description="Nova Versão Disponivel"
      @cancel="showModalNewVersion = false"
      @accept="reloadeScreen()"
    ></modal-new-version>

    <!-- modals adblock -->
    <modal-ad-block-detect
      description="Bloqueador de anúncios detectado"
      @accept="reloadeScreen()"
    ></modal-ad-block-detect>


    <section class="sidebar" :class="{ expand: activeExpand, isdemo: isDemo }">
      <div v-if="!isAdPixelPro" class="logo center">
        <center>
          <img class="no-mobile" src="@/assets/img/icon.png" width="60" />
          <div class="app-title no-mobile">Único Tracker</div>
          <div class="mobile">
            <i class="fas fa-bars"></i>
          </div>
        </center>
      </div>
      <div v-else class="logo center">
        <center>
          <img class="no-mobile" src="@/assets/img/icon-adpixelpro.png" width="60" />
          <div class="app-title no-mobile margin-top-s">AD Pixel PRO</div>
          <div class="mobile">
            <i class="fas fa-bars"></i>
          </div>
        </center>
      </div>

      <nav class="menu">
        <ul>
          <div class="sub-menu">
            <router-link v-if="checkResource('profit')" :to="{ name: 'Dash', params: {slug: 'profit'} }">
              <li>
                <i class="fas fa-flag-checkered"></i>
                <span>Dashboards</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </router-link>
            <div class="sub-itens">
              <router-link v-if="checkResource('profit')" :to="{ name: 'Dash', params: {slug: 'profit'} }">
                <li :class="{ current: $route.name === 'Dash' && $route.params.slug === 'profit' }">
                  <span>Vendas</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Dash', params: {slug: 'lead'} }">
                <li :class="{ current: $route.name === 'Dash' && $route.params.slug === 'lead' }">
                  <span>Captação de Leads</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Dash', params: {slug: 'message'} }">
                <li :class="{ current: $route.name === 'Dash' && $route.params.slug === 'message' }">
                  <span>Conversas (Whatsapp)</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('funnel')" :to="{ name: 'Dash', params: {slug: 'profit'} }">
                <li :class="{ current: $route.name === 'Dash' && $route.params.slug === 'profit' }">
                  <span>Funis</span>
                </li>
              </router-link>
            </div>
          </div>

          <div class="sub-menu">
            <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'sale'} }">
              <li>
                <i class="fas fa-bullseye"></i>
                <span>Origens</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </router-link>
            <div class="sub-itens">
              <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'sale'} }">
                <li :class="{ current: $route.name === 'Source' && $route.params.slug === 'sale' }">
                  <span>Vendas</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'lead'} }">
                <li :class="{ current: $route.name === 'Source' && $route.params.slug === 'lead' }">
                  <span>Leads</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Source', params: {slug: 'message'} }">
                <li :class="{ current: $route.name === 'Source' && $route.params.slug === 'message' }">
                  <span>Conversas (Whatsapp)</span>
                </li>
              </router-link>
            </div>
          </div>

          <div class="sub-menu">
            <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'sale'} }">
              <li>
                <i class="fab fa-pagelines"></i>
                <span>Jornada do Cliente</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </router-link>
            <div class="sub-itens">
              <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'sale'} }">
                <li :class="{ current: $route.name === 'Jorney' && $route.params.slug === 'sale' }">
                  <span>Vendas</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'lead'} }">
                <li :class="{ current: $route.name === 'Jorney' && $route.params.slug === 'lead' }">
                  <span>Leads</span>
                </li>
              </router-link>
              <router-link v-if="checkResource('profit')" :to="{ name: 'Jorney', params: {slug: 'message'} }">
                <li :class="{ current: $route.name === 'Jorney' && $route.params.slug === 'message' }">
                  <span>Conversas (Whatsapp)</span>
                </li>
              </router-link>
            </div>
          </div>

          <div>
            <router-link v-if="checkResource('funnel')" :to="{ name: 'Funnel', params: { slug: 'campaign' } }">
              <li
                :class="{
                  current: $route.name && $route.name === 'Funnel',
                }"
              >
                <i class="fas fa-funnel-dollar"></i>
                <span>Funis</span>
              </li>
            </router-link>
          </div>

          <div>
            <router-link v-if="checkResource('custom-conversion')" :to="{ name: 'CustomConversion', params: { slug: 'campaign' } }">
              <li
                :class="{
                  current: $route.name && $route.name === 'CustomConversion',
                }"
              >
                <i class="fas fa-chess-queen"></i>
                <span>Conversões Personalizadas</span>
              </li>
            </router-link>
          </div>

          <div>
            <router-link v-if="checkResource('campaigndash')" :to="{ name: 'CampaignDash', params: {slug: 'campaign'} }">
              <li
                :class="{
                  current: $route.name && $route.name === 'CampaignDash',
                }"
              >
                <i class="fas fa-route"></i>
                <span>Campanhas</span>
              </li>
            </router-link>
          </div>

          <router-link v-if="checkResource('product')" :to="{ name: 'Product' }">
            <li
              :class="{
                current: $route.name && $route.name === 'Product',
              }"
            >
              <i class="fas fa-clipboard-list"></i>
              <span>Produtos</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('insight')" :to="{ name: 'Insight' }">
            <li
              :class="{ current: $route.name && $route.name.includes('Insight') }"
              class="block-module"
            >
              <i class="fas fa-chart-area"></i>
              <span>Insights</span>
            </li>
          </router-link>


          <router-link v-if="checkResource('timelinelog')" :to="{ name: 'TimeLineLog' }">
            <li
              :class="{ current: $route.name && $route.name === 'TimeLineLog' }"
              class="block-module"
            >
              <i class="fas fa-sticky-note"></i>
              <span>Anotações</span>
            </li>
          </router-link>

          <router-link  v-if="checkResource('additionalvalue')" :to="{ name: 'AdditionalValue' }">
            <li :class="{ current: $route.name === 'AdditionalValue' }">
              <i class="fas fa-balance-scale-left"></i>
              <span>Valores Adicionais</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('config')" :to="{ name: 'Export' }">
            <li
              :class="{ current: $route.name && $route.name.includes('Export') }"
              class="block-module"
            >
              <i class="fas fa-download"></i>
              <span>Exportar Dados</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('ratestore')" :to="{ name: 'RateStore' }">
            <li
              :class="{ current: $route.name && $route.name.includes('RateStore') }"
            >
              <i class="fas fa-glasses"></i>
              <span>Avaliar Loja</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('calculateproduct') && false" :to="{ name: 'CalculateProduct' }">
            <li
              :class="{ current: $route.name && $route.name.includes('CalculateProduct') }"
            >
              <i class="fas fa-calculator"></i>
              <span>Calculadora de Preço</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('specialist')" :to="{ name: 'Specialist' }">
            <li
              :class="{ current: $route.name && $route.name.includes('Specialist') }"
              class="block-module"
            >
              <i class="fas fa-fire"></i>
              <span>O especialista</span>
            </li>
          </router-link>

          <router-link v-if="checkResource('vsl')" :to="{ name: 'VSL' }">
            <li
              :class="{ current: $route.name && $route.name.includes('VSL') }"
            >
              <i class="fas fa-video"></i>
              <span>VSL</span>
            </li>
          </router-link>

          <router-link v-if="false" :to="{ name: 'HowTo' }">
            <li :class="{ current: $route.name === 'HowTo' }">
              <i class="fas fa-info"></i>
              <span>Tutoriais</span>
            </li>
          </router-link>

          <router-link v-if="false" :to="{ name: 'Canny' }">
            <li :class="{ current: $route.name === 'Canny' }">
              <i class="fas fa-bullhorn"></i>
              <span>Sugestões</span>
            </li>
          </router-link>

          <router-link v-if="false" :to="{ name: 'Bonus' }">
            <li :class="{ current: $route.name === 'Bonus' }">
              <i class="far fa-star"></i>
              <span>Bonus</span>
            </li>
          </router-link>

          <router-link v-if="false" :to="{ name: 'Affiliate' }">
            <li :class="{ current: $route.name === 'Affiliate' }">
              <i class="fas fa-hand-holding-heart"></i>
              <span>Indique a LucreiHoje (30%)</span>
            </li>
          </router-link>

          <div id="installButton" style="display: none;">
            <li>
              <i class="fab fa-sketch"></i>
              <span>Instalar App</span>
            </li>
          </div>

          <hr />
          <div class="sub-menu">
            <router-link v-if="checkResource('shortlink')" :to="{ name: 'ShortLink' }">
              <li>
                <i class="fas fa-folder-open"></i>
                <span>Links Rastreaveis</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </router-link>
            <div class="sub-itens">
              <router-link
                v-if="checkResource('shortlink')"
                :to="{ name: 'ShortLink'}"
              >
                <li :class="{ current: $route.name === 'ShortLink' }">
                    <span>Links Orgânico</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('shortlink')"
                :to="{ name: 'ShortLinkWhats'}"
              >
                <li :class="{ current: $route.name === 'ShortLinkWhats' }">
                    <span>Links para WhatsApps</span>
                </li>
              </router-link>

            </div>
          </div>

          <div class="sub-menu">
            <router-link v-if="checkResource('profit')" :to="{ name: 'Track', params: {slug: 'trackingv2'} }">
              <li>
                <i class="fas fa-folder-open"></i>
                <span>Trackeamento</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </router-link>
            <div class="sub-itens">
              <router-link
                v-if="checkResource('trackingv2')"
                :to="{ name: 'Track', params: {slug: 'trackingv2'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'trackingv2' }">
                  <span>Hot Tracker (Pixel)</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('populatepixel')"
                :to="{ name: 'Track', params: {slug: 'populate-pixel'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'populate-pixel' }">
                    <span>Retro Alimentação (I.A)</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('domain')"
                :to="{ name: 'Track', params: {slug: 'domain'} }"
              >
                <li :class="{ current: $route.name === 'Track' && $route.params.slug === 'domain' }">
                  <span>Domínios</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('tracking')"
                :to="{ name: 'Track', params: {slug: 'taxtracker'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'taxtracker' }">
                  <span>Taxa de Tracker</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('tracking')"
                :to="{ name: 'Track', params: {slug: 'page-ignore'} }"
              >
                <li :class="{ current: $route.name === 'Track' && $route.params.slug === 'page-ignore' }">
                  <span>Páginas Ignoradas</span>
                </li>
              </router-link>


              <router-link
                v-if="checkResource('tracking') "
                :to="{ name: 'Track', params: {slug: 'whatsapp'} }"
              >
                <li :class="{ current: $route.name === 'Track'&& $route.params.slug === 'whatsapp' }">
                  <span>WhatsApps</span>
                </li>
              </router-link>

            </div>
          </div>

          <div class="sub-menu">
            <router-link v-if="checkResource('config')" :to="{ name: 'Config', params: {slug: 'account'} }">
              <li>
                <i class="fas fa-folder-open"></i>
                <span>Configurações</span>
                <i class="fas fa-chevron-down sub-menu-i"></i>
              </li>
            </router-link>
            <div class="sub-itens">
              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'account'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'account' }">
                  <span>Conta</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'account'} }"
              >
                <li>
                  <span>Assinatura</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'integracoes'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'integracoes' }">
                  <span>Integrações</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'imports'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'imports' }">
                  <span>Importações</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config')"
                :to="{ name: 'Config', params: {slug: 'user'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'user' }">
                  <span>Equipe (Usuários)</span>
                </li>
              </router-link>

              <router-link
                v-if="checkResource('config') && account && account.account_type === 'MANAGER'"
                :to="{ name: 'Config', params: {slug: 'project'} }"
              >
                <li :class="{ current: $route.name === 'Config'&& $route.params.slug === 'project' }">
                    <span>Projetos (Clientes)</span>
                </li>
              </router-link>
            </div>
          </div>

          <router-link v-if="hasMultipleAccounts" :to="{ name: 'Account' }">
            <li>
              <i class="fas fa-exchange-alt"></i>
              <span>Trocar de Projeto</span>
            </li>
          </router-link>

          <a @click="logout()">
            <li>
              <i class="fas fa-sign-out-alt"></i>
              <span>Sair</span>
            </li>
          </a>
        </ul>
        
      </nav>
      <div
      v-if="false"
      class="expand-button"
      @click="activeExpand = !activeExpand"
      >
      <small v-if="!activeExpand">Expandir</small>
      <small v-else>Minimizar</small>
    </div>
    <div class="version flex center margin-top-l">
      <small>Versão: {{ version }}</small>
    </div>
    </section>

    <section class="main-content" :class="{ expand: activeExpand }">
      <section class="top-bar grid-flex middle between">
        <div class="main-filters flex middle flex-1">
          <breadcrumb></breadcrumb>
        </div>
        <div class="flex end no-mobile">
          <a href="https://l.lh4.me/f3xgau" target="_blank">
            <div class="">
              <b>AJUDA (ACADEMY)</b>
            </div>
          </a>
        </div>
        <div class="flex middle">
          <div style="padding: 0px 16px; border-right: 1px solid #c2c2c2" class="flex column no-mobile">
              <div class="flex end w100">
                <div @click="changeProtect()" class="button secondary btn-download">
                  <i class="far fa-eye"></i>
                </div>
              </div>
            </div>
          <div style="margin-right: 24px; padding: 0px 16px; border-right: 1px solid #c2c2c2" class="flex column no-mobile">
              <div class="flex end w100">
                <div @click="downloadReport('dash-profit')" class="button secondary btn-download">
                  Baixar Relatório
                </div>
              </div>
            </div>
          <div v-if="false" class="" style="margin-right: 24px; padding: 12px 36px; border-right: 1px solid #c2c2c2">
            <router-link :to="{ name: 'Canny' }">
              <div :class="{ current: $route.name === 'Canny' }">
                <i class="fas fa-bullhorn" style="margin-right: 6px"></i>
                <span>Deixe a sua Sugestão</span>
              </div>
            </router-link>
          </div>
          <div>
            <project-selector :hasMultipleAccounts="hasMultipleAccounts"></project-selector>
          </div>
          <a @click="logout()" class="button secondary"
            ><i class="fas fa-sign-out-alt"></i
          ></a>
        </div>
      </section>

      <section id="report-screen" class="content-container flex w100 center column middle">
        <div id="banner-screen" class="w100 flex center column middle txt-center">
          <a href="https://unicotracker.com.br/?utm_source=report-pdf" target="_blank">
            <h3>
              RELATÓRIO FEITO PELA unicotracker.com.br - ({{ account.id }}) {{ account.name }}
            </h3>
            <p class="margin-top-s">Criado em: {{ Date() | date }}</p>
          </a>
        </div>
        <div
          v-if="
            (!isAccountBlocked && !isAccountLimitExceeded) ||
              ((isAccountLimitExceeded || isAccountBlocked) &&
                subscriptionRoute)
          "
          class="max-1200 w100"
          :class="{'max-width': routeMaxWidth }"
        >
          <slot></slot>
          
        </div>
        
        <div v-else-if="isAccountBlocked" class="max-1200 w100">
          <blocked></blocked>
        </div>
        <div v-else-if="isAccountLimitExceeded && isFreemium" class="max-1200 w100">
          <limit-exceeded-freemium></limit-exceeded-freemium>
        </div>
        <div v-else-if="isAccountLimitExceeded" class="max-1200 w100">
          <limit-exceeded></limit-exceeded>
        </div>
        <div id="banner-screen-end" class="w100 flex center column middle txt-center">
          <a href="https://unicotracker.com.br/?utm_source=report-pdf" target="_blank">
            <h3>
              RELATÓRIO FEITO PELA unicotracker.com.br
            </h3>
            <p class="margin-top-s">Crie sua conta GRATUITA.</p>
          </a>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import ProjectSelector from "@/components/ProjectSelector";
import FlagMarketingEmpty from "@/components/flag/FlagMarketingEmpty";
import SubscriptionFlag from "@/components/subscriptionFlag/SubscriptionFlag";
import SubscriptionFlagDemo from "@/components/subscriptionFlag/SubscriptionFlagDemo";
import SubscriptionFlagFree from "@/components/subscriptionFlag/SubscriptionFlagFree";
import Blocked from "@/components/blocked/Blocked";
import LimitExceeded from "@/components/blocked/LimitExceeded";
import LimitExceededFreemium from "@/components/blocked/LimitExceededFreemium";
import ModalOnboarding from "@/components/modal/ModalOnboarding.vue";
import ModalNewVersion from "@/components/modal/ModalNewVersion";
import ModalAdBlockDetect from "@/components/modal/ModalAdBlockDetect";

import { mapState } from "vuex";

import { Account } from "@/services/account";
import { getUser, AccountsList } from "@/services/user";
import { getVersionBack } from "@/services/version";

import { getIntegrationsStatus } from "@/services/integration";

export default {
  name: "Dashboard",
  components: {
    Breadcrumb,
    ProjectSelector,
    SubscriptionFlag,
    FlagMarketingEmpty,
    Blocked,
    LimitExceeded,
    ModalOnboarding,
    ModalNewVersion,
    ModalAdBlockDetect,
    SubscriptionFlagFree,
    SubscriptionFlagDemo,
    LimitExceededFreemium
  },
  data() {
    return {
      version: "1.0.6.17",
      activeExpand: false,
      showModalNewVersion: false,
      checkVersionInterval: null,
      showFlagFree: true,
      showFlagMarketing: true,
      emptyMarketing: false,
      checkFlagFreeInterval: null,
      accounts: [],
      AtiveProtect: false,
    };
  },
  mounted() {
    if (!this.account.status) {
      this.getAccountInfo();
    }

    if (!this.user.id) {
      this.getUserInfo();
    }

    this.getAccountsList();

    this.checkVersion();
    this.checkVersionInterval = setInterval(this.checkVersion, 1000 * 1 * 60);

    if (this.isFreemium) {
      this.checkFlagFreeInterval = setInterval(this.checkFlagFree, 1000 * 1 * 5);
    }

    this.getIntegrationsStatus()

    this.checkAppInstall()

    var checkActive = localStorage.getItem("ActiveProtect");
    if (checkActive) {
      this.AtiveProtect = true
    }
  },
  destroyed() {
    clearInterval(this.checkVersionInterval);
    clearInterval(this.checkFlagFreeInterval);

  },
  updated() {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    isAdPixelPro() {
      const currentDomain = window.location.hostname;
      if (currentDomain.includes("adpixel.pro")) {
        return true
      }

      return false
    },
    showOnboarding() {
      // return true;
      if (!this.user || (this.user && this.user.complet_onboarding === "")) {
        return false;
      }

      return this.user && !this.user.complet_onboarding;
    },
    hasMultipleAccounts() {
      return this.accounts && this.accounts.length > 1;
    },
    isDemo() {
      // let demoAccId =
      //   process && process.env && process.env.VUE_APP_DEMO_ACCOUNT;
      // return demoAccId == this.account.id;

      return false
    },
    isPaymentEmpty() {
      return this.account && this.account.flag_payment
    },
    isFreemium() {
      return this.account && this.account.plan && this.account.plan.toLowerCase().includes('freemium')
    },
    isAccountBlocked() {
      return this.account && this.account.status === "BLOCKED";
    },
    isAccountLimitExceeded() {
      return this.account && this.account.status === "LIMIT_EXCEEDED";
    },
    subscriptionRoute() {
      console.log('this.$route.name', this.$route.name)
      if (['SubscriptionRedirect', 'Config','ConfigAccount','ConfigIntegration','ConfigIntegrationDetail'].includes(this.$route.name)) {
        return true
      }
      return false
    },
    routeMaxWidth() {
      if (['CampaignDash'].includes(this.$route.name)) {
        return true
      }
      return false
    },
  },
  methods: {
    changeProtect() {
      this.AtiveProtect = !this.AtiveProtect
      if (this.AtiveProtect) {
        localStorage.setItem("ActiveProtect",this.AtiveProtect);
      } else {
        localStorage.removeItem("ActiveProtect");
      }
      document.location.reload(true);

    },
    checkAppInstall() {
        let deferredPrompt;
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt = e;
            const installButton = document.getElementById('installButton');
            installButton.style.display = 'block';

            installButton.addEventListener('click', () => {
                installButton.style.display = 'none';
                deferredPrompt.prompt();
                deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the install prompt');
                    } else {
                        console.log('User dismissed the install prompt');
                    }
                    deferredPrompt = null;
                });
            });
        });
    },
    downloadReport() {
      var element = document.getElementById('report-screen');
      var bannerReport = document.getElementById('banner-screen');
      var bannerReportEnd = document.getElementById('banner-screen-end');
      if (!window.html2pdf) {
        this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
          return
      }

      bannerReport.style.display ='flex'
      bannerReportEnd.style.display ='flex'

      this.$toast.success({
        title:'Sucesso',
        message:'Gerando o PDF do relatório. Aguarde'
      })

      window.html2pdf(element, {
          margin: [10, 10, 10, 50],
          filename: `report-lucreihoje-account-${this.account.id}-${this.$route.name}.pdf`,
          image: { type: 'jpg', quality: 0.98 },
          html2canvas: { dpi: 192, scale: 1, letterRendering: true },
          jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }
      })
      .then(() => {
        bannerReport.style.display = 'none'
        bannerReportEnd.style.display = 'none'
      })
    },
    checkFlagFree() {
      this.showFlagFree = true
    },
    getIntegrationsStatus() {
      getIntegrationsStatus()
      .then((result) => {
        let fbEmpty = false
        if (result.facebookads.status == 'DISABLE' || result.facebookads.accounts.length == 0) {
          fbEmpty = true
        }
        let gEmpty = false
        if (result.googleads.status == 'DISABLE' || result.googleads.accounts.length == 0) {
          gEmpty = true
        }

        if (fbEmpty && gEmpty) {
          this.emptyMarketing = true
        }
      })
    },
    checkVersion() {
      getVersionBack().then(resultVersion => {
        if (!resultVersion.version) {
          return;
        }
        let frontVersion = parseInt(this.version.replaceAll(".", ""), "10");

        let auxVersion = resultVersion.version.replaceAll(".", "");
        auxVersion = parseInt(auxVersion, "10");

        if (frontVersion < auxVersion) {
          this.showModalNewVersion = true;
        }
      });
    },
    reloadeScreen() {
      document.location.reload(true);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    getUserInfo() {
      getUser().then((result) => {
        this.$store.dispatch("auth", result);
      });
    },
    getAccountsList() {
      AccountsList().then((response) => {
        this.accounts = response;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.top-bar {
  .button.secondary {
    background: none;
    color: var(--primary);
    border: 0px;
    white-space: nowrap;
    padding: 12px 16px;
    font-size: 1.5rem;
    display: inline-block;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      background: var(--secondary);
      color: #fff !important;
    }
  }
}

.menu {
  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top-color: currentcolor;
    border-top-style: none;
    border-top-width: 0px;
    border-top: 1px solid #c2c2c235;
    padding: 0;
    margin: 8px 0;
  }
}

.btn-download {
  border: 1px solid var(--terciary) !important;
}

#banner-screen {
  display: none;
  padding: 24px;
  background: var(--primary);
  color: #fff;
  margin-bottom: 14px;
  a {
    color: #fff;
  }
}
#banner-screen-end {
  display: none;
  padding: 24px;
  background: var(--primary);
  color: #fff;
  margin-bottom: 14px;
  a {
    color: #fff;
  }
}

.sub-itens {
  display: none;
}

.menu {
  li:hover {
    background: var(--primary);
    color: #fff;
  }
  .sub-menu {
    .sub-itens {
      transition: all 0.9s ease; /* Define a transição para mudanças */
    }
  }
  .sub-menu:hover {
    transition: opacity 0.9s ease, transform 0.9s ease, visibility 0.9s ease;
    transform: translateX(4px);
    .sub-itens {
      display: inline-block;
      padding-left: 16px;
      li {
        // border-left: 1px solid #eee; 
        margin-left: 8px;
        border-left: 2px solid #eee;
        padding: 8px;
        border-radius: 0px !important;
        margin-top: 0px !important;
      }
    }
  }
}

.app-title {
  margin-top: 8px;
}
</style>
